import WidgetRenderer from "../components/WidgetRenderer";

export default function Group({ config, value, onChange, mode }) {
  return (
    <div>
      {config.parts?.map((part) => (
        <WidgetRenderer
          key={part.id}
          question={part}
          value={value?.[part.id]}
          onChange={(val) => {
            onChange({
              ...(value || {}),
              [part.id]: val
            });
          }}
          mode={mode}
        />
      ))}
    </div>
  );
}

